'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var ACCOUNT = 'M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z';
var IconAccount = lib.variant('IconAccount', icon.Icon, {
    path: ACCOUNT,
});

exports.IconAccount = IconAccount;
//# sourceMappingURL=index-b26c081d.js.map
